import { createStore, applyMiddleware } from 'redux';
import promiseMiddleware from 'redux-promise';
import reducers from './reducers/index';
import apiMiddleware from './middleware';

const createStoreWithMiddleware = applyMiddleware(apiMiddleware,promiseMiddleware)(createStore)
const store = createStoreWithMiddleware(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

// store.subscribe(() => console.log('store', store.getState()));

export default store;
